import React, { PureComponent } from 'react';
import type { WrappedComponentProps } from 'react-intl-next';
import { defineMessages, injectIntl } from 'react-intl-next';

import Button from '@atlaskit/button';

import { EmptyStateWrapper } from './EmptyStateWrapper';
import emptyImage from './Empty.svg';

const i18n = defineMessages({
	header: {
		id: 'template-list.empty.headline',
		defaultMessage: 'We’re fresh out of templates',
		description:
			'This is the headline that shows when the user’s selected space does not have any available templates',
	},
	description: {
		id: 'template-list.empty.description',
		defaultMessage:
			'There aren’t any templates in this space, but there are still lots of way to make your pages pop.',
		description:
			'This is the description that shows when the user’s selected space does not have any available templates',
	},
});

const HandyTipLink = (
	<Button
		appearance="link"
		href="https://support.atlassian.com/confluence-cloud/docs/add-formatting-to-your-page/"
	>
		Check out these tips
	</Button>
);

export const EmptyTemplateList = injectIntl(
	class EmptyTemplateList extends PureComponent<WrappedComponentProps> {
		render() {
			return (
				<EmptyStateWrapper
					header={this.props.intl.formatMessage(i18n.header)}
					description={this.props.intl.formatMessage(i18n.description)}
					primaryAction={HandyTipLink}
					imageUrl={emptyImage}
					imageHeight={75}
				/>
			);
		}
	},
);
